import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2 } from "lucide-react";
import { api } from "../../../services/apiService";
import { apiMessage } from "../apiMessage";
import { AuthLayout } from "../components/AuthLayout";

export function PasswordResetPage() {
  const [params] = useSearchParams();
  const [email, setEmail] = useState("");
  const [token, setToken] = useState(params.get("token") || "");
  const [password, setPassword] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const reset = Boolean(token);

  const submit = async (event) => {
    event.preventDefault();
    setError("");
    setMessage("");
    setSubmitting(true);

    const endpoint = reset ? "reset-password" : "forgot-password";
    const body = reset ? { token, password } : { email };

    try {
      const response = await api.post(`/auth/${endpoint}`, body);
      setMessage(response.data.message);
    } catch (err) {
      setError(apiMessage(err, "Request failed"));
    } finally {
      setSubmitting(false);
    }
  };

  if (message) {
    return (
      <AuthLayout eyebrow="Account security" title="Check your inbox">
        <div className="auth-status">
          <div className="auth-status-icon"><CheckCircle2 size={26} /></div>
          <p style={{ color: "var(--ops-muted)", fontSize: 14, lineHeight: 1.6 }}>{message}</p>
          <Link to="/login" className="ops-button ops-button--secondary" style={{ marginTop: 20 }}>
            Back to sign in
          </Link>
        </div>
      </AuthLayout>
    );
  }

  return (
    <AuthLayout
      eyebrow="Account security"
      title={reset ? "Set a new password" : "Reset your password"}
      subtitle={reset ? "Choose a new password for your account." : "Enter your email and we'll send you reset instructions."}
    >
      <form onSubmit={submit} className="auth-form">
        {!reset ? (
          <div>
            <label className="ops-form-label">Email address</label>
            <input
              required
              type="email"
              className="ops-input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
        ) : (
          <>
            <div>
              <label className="ops-form-label">Reset token</label>
              <input
                required
                className="ops-input"
                value={token}
                onChange={(e) => setToken(e.target.value)}
              />
            </div>
            <div>
              <label className="ops-form-label">New password</label>
              <input
                required
                minLength={8}
                type="password"
                className="ops-input"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              <span className="ops-form-hint">At least 8 characters.</span>
            </div>
          </>
        )}

        {error && <div className="ops-alert ops-alert--error">{error}</div>}

        <button type="submit" className="ops-button ops-button--primary auth-submit" disabled={submitting}>
          {submitting ? "Submitting…" : reset ? "Update password" : "Send reset instructions"}
        </button>
      </form>

      <div className="auth-footer">
        <Link to="/login">Back to sign in</Link>
      </div>
    </AuthLayout>
  );
}
